import { render } from "./DropData.vue?vue&type=template&id=88e4c22e&scoped=true"
import script from "./DropData.vue?vue&type=script&lang=js"
export * from "./DropData.vue?vue&type=script&lang=js"

import "./DropData.vue?vue&type=style&index=0&id=88e4c22e&lang=less"
import "./DropData.vue?vue&type=style&index=1&id=88e4c22e&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e4c22e"]])

export default __exports__